export default "__VITE_ASSET__86d8bbc5__"